import { heroLead, heroSideCards, siteMeta, tickerItems } from '@/mocks/homeData';

export default function HeroSection() {
  const tickerLoop = [...tickerItems, ...tickerItems];

  return (
    <section id="today" className="w-full border-b border-background-200 bg-background-100">
      <div className="w-full overflow-hidden border-b border-background-200 bg-background-50 py-2">
        <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap px-4 text-xs text-foreground-600">
          {tickerLoop.map((text, index) => (
            <span key={`${text}-${index}`} className="flex items-center gap-2">
              <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
              {text}
            </span>
          ))}
        </div>
      </div>

      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div className="animate-fade-up">
            <p className="flex items-center gap-2 text-xs tracking-[0.3em] text-primary-600">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-flashlight-line" />
              </span>
              今日六点档 · TODAY 18:00
            </p>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              每天一条完整事件，
              <br className="hidden md:block" />
              不用再东拼西凑
            </h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">{siteMeta.slogan}</p>
          </div>

          <div className="flex gap-3">
            <div className="rounded-lg border border-background-200 bg-background-50 px-4 py-3">
              <p className="font-heading text-2xl font-bold text-primary-600">{siteMeta.todayCount}</p>
              <p className="mt-0.5 text-xs text-foreground-600">今日专题</p>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-50 px-4 py-3">
              <p className="font-heading text-2xl font-bold text-foreground-950">{siteMeta.onlineCount}</p>
              <p className="mt-0.5 text-xs text-foreground-600">在线围观</p>
            </div>
            <div className="rounded-lg border border-accent-200 bg-accent-50 px-4 py-3">
              <p className="font-heading text-2xl font-bold text-accent-700">{siteMeta.archiveCount}</p>
              <p className="mt-0.5 text-xs text-foreground-600">往期归档</p>
            </div>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-12">
          <a
            href="#topics"
            className="group col-span-1 flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:col-span-7"
          >
            <div className="relative h-56 w-full overflow-hidden md:h-80">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20editorial%20flat%20lay%20of%20torn%20paper%20notes%20and%20speech%20bubble%20cutouts%20connected%20by%20red%20thread%20on%20beige%20desk%2C%20soft%20shadows%2C%20muted%20vermillion%20and%20amber%20accents%2C%20abstract%20storytelling%20composition&width=1200&height=800&seq=hl6-hero-lead-01&orientation=landscape"
                alt="黑料六点档 今日专题 时间线梳理配图"
                title="黑料六点 时间线梳理 今日专题"
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                {heroLead.tag}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5">
              <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                {heroLead.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600">{heroLead.summary}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {heroLead.meta.map((item) => (
                  <span key={item} className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
                    {item}
                  </span>
                ))}
              </div>
              <span className="mt-4 flex items-center gap-1.5 text-sm text-primary-600">
                查看完整专题
                <span className="flex h-4 w-4 items-center justify-center transition-transform group-hover:translate-x-1">
                  <i className="ri-arrow-right-line" />
                </span>
              </span>
            </div>
          </a>

          <div className="col-span-1 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-5 lg:grid-cols-1">
            {heroSideCards.map((card) => (
              <a
                key={card.title}
                href="#topics"
                className="group flex items-stretch gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-200"
              >
                <div className="h-24 w-24 shrink-0 overflow-hidden rounded-md">
                  <img
                    src={card.image}
                    alt={`黑料六点 专题整理 ${card.tag} 配图`}
                    title={`黑料六点档 ${card.tag}`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="flex min-w-0 flex-col justify-center py-1">
                  <span className="text-xs text-accent-700">{card.tag}</span>
                  <h3 className="mt-1 text-sm font-medium leading-snug text-foreground-950">{card.title}</h3>
                  <span className="mt-2 text-xs text-foreground-500">{card.meta}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}